import { apiConfig } from '@/services/api-config';

export interface GetReportParms {
  tokenKey: string;
  cdTerritory: string;
  cdUser: string;
}

export const getReport = async ({ tokenKey, cdTerritory, cdUser }: GetReportParms) => {
  const tmxToken = sessionStorage.getItem('chave');
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') || '{}');

  const payload = {
    analysisCode: process.env.VUE_APP_ANALISE,
    territoryId: cdTerritory,
    userId: cdUser.toString(),
    companyId: userLogged.company.idCompany.toString(),
    tokenKey,
  };

  const getReportUri = 'api/territory/analysis';

  return apiConfig
    .post(getReportUri, payload, {
      headers: {
        Authorization: `${tmxToken}`,
      },
    })
    .then((resp) => resp.data.objectResult);
};
